const MCAMapPinLight = () => {
	return (
		<>
			<path
				d="M32.0003 5.83337C42.044 5.83355 50.1664 13.9566 50.1664 24.0004C50.1663 27.3991 49.0304 31.2411 47.2933 35.1185C45.5591 38.9895 43.2431 42.8598 40.9193 46.3041C38.5964 49.7469 36.2722 52.7554 34.5287 54.9037C33.6571 55.9776 32.9308 56.836 32.4232 57.4252C32.2585 57.6163 32.1155 57.7779 31.9994 57.9105C31.8833 57.778 31.7409 57.616 31.5765 57.4252C31.0689 56.836 30.3435 55.9775 29.472 54.9037C27.7285 52.7554 25.4042 49.7468 23.0814 46.3041C20.7575 42.8597 18.4406 38.9896 16.7064 35.1185C14.9693 31.2411 13.8334 27.3991 13.8333 24.0004C13.8333 13.9565 21.9565 5.83337 32.0003 5.83337Z"
				fill="#F5F9FF"
				stroke="#0B2341"
			/>
			<path
				d="M37.6462 16.7812C36.0676 16.7812 34.7755 17.7959 32.9621 19.333C32.133 17.5492 30.4855 16.8006 28.755 16.8006C27.1926 16.8006 25.516 18.0877 24.1635 19.2826L23.1298 17.1256H21.7461V31.1992H24.2228V20.0516C25.9672 18.9619 27.2378 18.6122 28.1628 18.6122C29.8006 18.6122 30.9183 20.1138 30.9183 22.2666V31.2003H33.395V21.6112C33.4057 21.0602 33.3416 20.5104 33.2044 19.9765C34.8832 18.9468 36.1204 18.6122 37.0217 18.6122C38.6595 18.6122 39.7772 20.1138 39.7772 22.2666V31.2003H42.2539V21.3774C42.2571 18.5607 40.3555 16.7812 37.6462 16.7812Z"
				fill="#0B2341"
			/>
		</>
	);
};

export default MCAMapPinLight;
